"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootRowCard: {
    display: 'flex',
    padding: '40px',
    borderRadius: '5px',
    boxShadow: "0px 2px 4px ".concat(_theme.default.palette.shadow),
    justifyContent: 'space-between',
    fontFamily: _theme.default.typography.proxima.regular,
    background: _theme.default.palette.white,
    [_theme.default.breakpoints.down('lg')]: {
      padding: '30px 20px'
    },
    [_theme.default.breakpoints.down('md')]: {
      padding: '30px 18px'
    },
    [_theme.default.breakpoints.down('sm')]: {
      padding: '30px 20px'
    }
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    color: _theme.default.palette.primary.main,
    fontFamily: _theme.default.typography.proxima.semiBold,
    paddingRight: '6px',
    lineHeight: '19px'
  },
  checkBoxWrapper: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginRight: '-4px',
    marginLeft: 0,
    '& .MuiCheckbox-root': {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
});
var _default = exports.default = useStyles;